var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Suggestions',{attrs:{"suggestions":_vm.visibleSuggestions},on:{"add":_vm.addSuggestion,"reject":_vm.rejectSuggestion}})
}
var staticRenderFns = []

export { render, staticRenderFns }